var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 3.3335H5.66667M3.13333 14.6668H6.86667C7.6134 14.6668 7.98677 14.6668 8.27199 14.5215C8.52287 14.3937 8.72684 14.1897 8.85468 13.9388C9 13.6536 9 13.2802 9 12.5335V3.46683C9 2.72009 9 2.34672 8.85468 2.06151C8.72684 1.81063 8.52287 1.60665 8.27199 1.47882C7.98677 1.3335 7.6134 1.3335 6.86667 1.3335H3.13333C2.3866 1.3335 2.01323 1.3335 1.72801 1.47882C1.47713 1.60665 1.27316 1.81063 1.14532 2.06151C1 2.34672 1 2.72009 1 3.46683V12.5335C1 13.2802 1 13.6536 1.14532 13.9388C1.27316 14.1897 1.47713 14.3937 1.72801 14.5215C2.01323 14.6668 2.3866 14.6668 3.13333 14.6668Z",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.fb59c834761a86aa64ff0b829b39ffdd.svg";
export { ForwardRef as ReactComponent };